import i18next from "i18next";
import * as jqueryI18next from "jquery-i18next";
import { Top } from "./Top";
//import { jazyk_cs as lng_cs } from "../lang/cs.js";
//import { jazyk_sk as lng_sk } from "../lang/sk.js";

var Translation = {
  neco: "text1",
  jeIframe: false,
  idStrany: false,
  zobrazWidget: false,
  zobrazitKonfiguratorZbrane: true, //lze vypnout kompletne na strankach
  Uzivatel: {
    prihlasen: null,
    overeniPrihlaseni: function() {
      var $a = $('a[href="/klient/"]');
      if ($a.length) return true;

      return false;
    },

    jePrihlasen: function() {
      return Translation.Uzivatel.prihlasen;
    },
  },
  l: function(id, options = {}) {
    return i18next.t(id, options);
  },
  obj: function(id) {
    return window.LdzTr[Top.jazyk].translation[id] || {};
  },
  _init: function() {
    //let lng = window.getShoptetDataLayer("language") || "cs";
    let lng = Top.jazyk;
    Lc.f("_init", lng);
    i18next.init({
      lng: lng, // if you're using a language detector, do not define the lng option
      debug: true,
      resources: window.LdzTr,
    });
    jqueryI18next.init(i18next, $, {
      tName: "t", // --> appends $.t = i18next.t
      i18nName: "i18n", // --> appends $.i18n = i18next
      handleName: "localize", // --> appends $(selector).localize(opts);
      selectorAttr: "data-i18n", // selector for translating elements
      targetAttr: "i18n-target", // data-() attribute to grab target element to translate (if diffrent then itself)
      optionsAttr: "i18n-options", // data-() attribute that contains options, will load/set if useOptionsAttr = true
      useOptionsAttr: false, // see optionsAttr
      parseDefaultValueFromContent: true, // parses default values from content ele.val or ele.text
    });
    //let $stav = Translation.Uzivatel.overeniPrihlaseni();
    //Translation.Uzivatel.prihlasen = $stav;
  },
};

Translation._init();

export { Translation };
